import React, { useState } from 'react';
import QRCode, {MockQRCode} from './QRCode/QRCode';
import Button from '../../../components/UI/Button/Button';
import Card from '../../../components/UI/Card/Card';

import { fetchDemoPrivateKey, decode, decodePhenoPacket } from 'rxome-generator';

const DemoCodeReader = (props) => {
  const [data, setData] = useState( null );
  const [privKey, setPrivKey] = useState( null );

  const decodeData = async ( privKey, data ) => {
    const b64 = await decode( privKey, data.payload );
    const buff = Buffer.from ( b64, 'base64' );
    const pheno = decodePhenoPacket( buff );
    const medical = JSON.parse( JSON.stringify( pheno ));
    data.payload = medical;
    setData( data );
  }

  const changeDataHandler = async (data) => {
    // yes it's weired, but it's due to the unpredictable behavior of setPrivKey
    if ( !privKey ) {
      fetchDemoPrivateKey()
      .then( (key) => {
        setPrivKey( key.private_key.trim() );
        decodeData( key.private_key.trim(), data )
      })
    } else {
      console.log('nothing to do')
      decodeData( privKey, data );
    }
  }

  return <>
    { data 
      ? <>
          <Button onClick={ () => setData(null) }>Read again</Button><br/>
          <Card>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </Card>
        </>
      : <QRCode onSetData={changeDataHandler} />
    }
  </>
}

export default DemoCodeReader;
